<template lang="pug">
.briq-form-element.briq-checkbox(:class="{disabled: $attrs.disabled}" :data-test-id="label")
  label.type-standard
    input(
      type="checkbox"
      :checked="checked"
      @change="toggle"
      v-bind="$attrs"
      )
    span.icon-span.mr-XXS
      BriqIcon(name="icon-input-checkbox-icon" :customStyle="{color: 'white'}")
    span {{ label }}
    span.required-marker.pl-XXXS(v-if="this.$attrs.required") *
  p.form-help-text(v-if="help") {{ help }}
  .validation-message(v-if="error") {{ error }}
</template>

<script>
import BriqIcon from '@/vue/components-global/BriqIcon.vue'

export default {
  name: 'BriqCheckbox',
  components: { BriqIcon },
  inheritAttrs: false,
  props: {
    value: Boolean,
    label: String,
    help: String,
    error: String,
  },
  data() {
    return { checked: this.value }
  },
  methods: {
    toggle() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    },
  },
  watch: {
    value(newVal) {
      this.checked = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
.required-marker
  color #4e5a6a

span.icon-span
  outline none
  width 17px
  height 17px
  border-radius 3px
  background #ffffff
  border solid 1px #ececec
  display inline-block
  vertical-align middle
  margin-right 5px
  position relative
  top 2px

.briq-checkbox input:checked + .icon-span
  background #00aaff
  border-color #00aaff

// todo: merge this when migrating the styles from forms.less to this component
.briq-checkbox
  background transparent
  padding 7px
  border none
  user-select none

.briq-checkbox input
  position fixed
  opacity 0
  width 0
  height 0

  &:focus + span
    outline 1px dotted

  &:checked + span
    background #4e5a6a
    border-color #4e5a6a

    .icon
      display block

.briq-checkbox label
  font-weight normal
  cursor pointer
  display flex

.briq-checkbox.disabled
  label
    cursor not-allowed
    opacity .5

  .briq-checkbox input:checked + .icon-span
    background #4e5a6a
    border-color #4e5a6a
</style>

<style lang="stylus">
.briq-checkbox
  .icon
    font-size 10px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
</style>
